var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-lg-flex main-app"},[_c('BaseHeader',{attrs:{"version":"v2"}}),_c('main',{staticClass:"flex-grow-1 pt-lg-6"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }